import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import UserMiddleware from "./Middleware/UserMiddleware";
import IsUser from './components/IsUser';

export default function App() {
  const router = createBrowserRouter([
    {path:"/",element:<UserMiddleware/>},
    {path:"/admin",element:<UserMiddleware/>}
  ])
  return <RouterProvider router={router}/>
}
